import { render } from "./noauth.vue?vue&type=template&id=7280713b"
const script = {}

import exportComponent from "D:\\xampp\\htdocs\\projects\\tahdir-v2\\tahdir-students-scan\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__